
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dtl-originals",
      function () {
        return require("private-next-pages/dtl-originals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dtl-originals"])
      });
    }
  